import type { MortgageTermsData, PaymentFrequency } from '../types/mortgageTypes';
import { getPaymentsPerYear } from './mortgageCalculations';

/** Canada VRM: fixed payment; schedule may extend past entered amortization. */
export const isCanadaFixedPaymentVrm = (terms: MortgageTermsData): boolean =>
  terms.country === 'Canada' &&
  terms.mortgageType === 'variable' &&
  terms.variableDetails?.variableType === 'vrm';

/**
 * Loans that may run past the nominal payment count (safety extension for USA ARM).
 */
export const needsExtendedHorizon = (terms: MortgageTermsData): boolean => {
  if (isCanadaFixedPaymentVrm(terms)) return true;
  if (terms.country === 'USA' && terms.mortgageType === 'adjustable' && terms.armDetails) {
    return true;
  }
  return false;
};

export const getNominalPaymentCount = (
  amortizationPeriod: number,
  paymentFrequency: PaymentFrequency
): number => amortizationPeriod * getPaymentsPerYear(paymentFrequency);

/** Hard stop so payment < interest paths cannot loop forever. */
export const getMaxPaymentCount = (
  amortizationPeriod: number,
  paymentFrequency: PaymentFrequency,
  terms: MortgageTermsData
): number => {
  const paymentsPerYear = getPaymentsPerYear(paymentFrequency);
  const nominal = amortizationPeriod * paymentsPerYear;
  if (!needsExtendedHorizon(terms)) return nominal;
  return Math.min(nominal * 2, 50 * paymentsPerYear);
};
